import { observer } from 'mobx-react-lite'
import classNames from 'classnames'
import { type CountryCode } from 'libphonenumber-js'
import { Checkbox, Typography } from 'shared/ui'
import { CountryFlag } from 'shared/ui/CountryFlag/CountryFlag'

import styles from './styles.module.scss'

type ICountryRowProps = {
  country: CountryCode
  label: string
  checked: boolean
  onToggle: (country: CountryCode) => void
}

export const CountryRow = observer(({ country, label, checked, onToggle }: ICountryRowProps) => (
  <label className={classNames(styles.row, { [styles.rowSelected]: checked })}>
    <Checkbox
      className={styles.checkbox}
      checked={checked}
      onChange={() => onToggle(country)}
      size={16}
      ariaLabel='CountryRow_checkbox'
    />
    <CountryFlag country={country} width={16} />
    <Typography className={styles.label} variant='body-rg-regular' ariaLabel='CountryRow_label'>
      {label}
    </Typography>
  </label>
))
